<template>
  <v-treeview
    ref="wTreeview"
    v-bind="$props"
    :key="key"
    class="w-treeview"
    dense
    :open.sync="openIds"
    v-on="$listeners"
  >
    <template
      v-for="(index, name) in $scopedSlots"
      #[name]="data"
    >
      <slot
        :name="name"
        v-bind="data"
      />
    </template>
  </v-treeview>
</template>
<script>
import { VTreeview } from 'vuetify/lib';

export default {
  props: {
    ...VTreeview.options.props,
  },
  data() {
    return {
      openIds: [],
      key: 0
    }
  },
  watch: {
    items(){
      if (this.selectable) this.key++ 
    },
    search(){
      (this.search == null || this.search == "") ? this.closeAll() : this.updateAll();
      if (this.search) this.$emit('update:search')
    }
  },
  methods: {
    updateAll() {
      this.$refs.wTreeview.updateAll(true);
    },
    closeAll(){
      this.$refs.wTreeview.updateAll(false);
    }
  }
};
</script>
<style lang="scss">
.w-treeview {
  .v-icon svg {
    box-shadow: $checkbox-inside-shadow;
  }
  .v-treeview-node--leaf > .v-treeview-node__root {
    padding-left: 2rem;
  }
  .v-treeview-node__level {
    display: none;
  }

  .v-treeview-node--disabled .v-treeview-node__checkbox {
    opacity: $disabled-opacity;
  }
  .v-treeview-node__root::before{
    background-color: $base-hover-color;
  }
}

// remove indentation after 7th level
.w-treeview
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children
  .v-treeview-node__children {
  .v-treeview-node {
    margin-left: 0 !important;
  }
}
</style>
